import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { ProjectsPage } from "@/pages/realisaties";

export const Route = createFileRoute("/realisaties")({
  head: () => {
    const t = i18n.getFixedT("nl", "projects");
    return pageHead({ lang: "nl", pathWithoutLang: "/realisaties", title: t("seo.title"), description: t("seo.description") });
  },
  component: ProjectsPage,
});
